import React from 'react'

export type Props = {
  src: string
  loop: boolean
}

export const VideoPlayer = (props: Props) => {
  return props.src ? (
    <video
      src={props.src}
      autoPlay
      playsInline
      loop={props.loop}
      controlsList="nodownload,nofullscreen,noremoteplayback"
      controls={false}
      disablePictureInPicture
      disableRemotePlayback
      onContextMenu={(e) => e.preventDefault()}
    />
  ) : null
}
